/**
 * Encabezados de reportes de asistencia / discipulado / pastoral.
 * Usar ReportColumnHeader o NoTranslateText para evitar traducciones erróneas del navegador, p. ej.:
 * - "Asist." → "Ayuda."
 * - "Cargo" → "Carga"
 * - "asistieron" → "audición"
 */

export const COL_NOMBRE = "Nombre";
/** Rol pastoral (líder, co-líder, etc.) — no confundir con "Carga". */
export const COL_CARGO = "Cargo";
export const COL_DIRIGE = "Célula que dirige";
export const COL_HIJA = "Célula hija (contexto)";
export const COL_CONVOCADOS = "Convocados";
export const COL_ASISTENCIA = "Asistencia";
export const COL_PORCENTAJE_ASISTENCIA = "% asistencia";
export const COL_ASISTIO = "Asistió";
export const COL_MOTIVO_AUSENCIA = "Motivo ausencia";
export const COL_MOTIVO = "Motivo";
export const COL_OBSERVACION = "Observación";
export const COL_FECHA = "Fecha";
export const COL_CELULA_MADRE = "Célula madre";
export const COL_MADRE = "Madre";
/** Alias histórico — usar COL_PORCENTAJE_ASISTENCIA */
export const COL_PORCENTAJE = COL_PORCENTAJE_ASISTENCIA;

/** Etiqueta segura (evita ReferenceError si falta una constante). */
export function safeColumnLabel(label, fallback = "—") {
  return label != null && String(label).trim() !== "" ? String(label) : fallback;
}

/** Informe: historial por célula madre (alineado con backend DISC_REPORT_BY_MOTHER_HEADERS) */
export const DISC_REPORT_BY_MOTHER_COLUMNS = [
  { key: "parent_cell_name", label: COL_CELULA_MADRE, align: "left" },
  { key: "meeting_date", label: COL_FECHA, align: "left" },
  { key: "total_convocados", label: COL_CONVOCADOS, align: "center" },
  { key: "total_asistentes", label: COL_ASISTENCIA, align: "center" },
  { key: "porcentaje_asistencia", label: COL_PORCENTAJE_ASISTENCIA, align: "center" },
];

/** Informe: ausentes / asistentes / por líder (alineado con DISC_REPORT_DETAIL_HEADERS) */
export const DISC_REPORT_DETAIL_COLUMNS = [
  { key: "meeting_date", label: COL_FECHA, align: "left" },
  { key: "parent_cell_name", label: COL_MADRE, align: "left" },
  { key: "attendee_name", label: COL_NOMBRE, align: "left" },
  { key: "role_label_es", label: COL_CARGO, align: "left" },
  { key: "attended", label: COL_ASISTIO, align: "center" },
  { key: "absence_reason", label: COL_MOTIVO, align: "left" },
];

/** Convocatoria (formulario + Excel/PDF) — orden alineado con backend DISC_SHEET_HEADERS */
export const DISC_ATTENDANCE_TABLE_HEADERS = [
  COL_NOMBRE,
  COL_CARGO,
  COL_DIRIGE,
  COL_HIJA,
  COL_ASISTIO,
  COL_MOTIVO_AUSENCIA,
  COL_OBSERVACION,
];

/** Texto visible sin traducción automática (UI, tarjetas, opciones, gráficas). */
export function NoTranslateText({ children, className, as: Tag = "span" }) {
  const Comp = Tag;
  return (
    <Comp className={`notranslate ${className || ""}`.trim()} translate="no" lang="es">
      {children}
    </Comp>
  );
}

/** Alias para encabezados de tabla */
export function ReportColumnHeader({ children, className }) {
  return <NoTranslateText className={`inline-block ${className || ""}`.trim()}>{children}</NoTranslateText>;
}

/** Informes pastorales — tipo «no_sunday» y columnas de ausentes */
export const PASTORAL_COL_ASISTENCIA_CELULA = "Asistencia célula";
export const PASTORAL_COL_ASISTENCIA_DOMINGO = "Asistencia domingo";
export const PASTORAL_REPORT_NO_SUNDAY = "No asistieron domingo";
export const PASTORAL_SUB_NO_ASISTIO_DOMINGO = "No asistió a domingo";
export const PASTORAL_SUB_NO_ASISTIO_CELULA = "No asistió a célula";
export const PASTORAL_CHART_AUSENTES_DOMINGO = "Ausentes domingo";

export const PASTORAL_REPORT_OPTIONS = [
  { value: "absent", label: "Ausentes" },
  { value: "no_devotional", label: "Sin devocional" },
  { value: "no_sunday", label: PASTORAL_REPORT_NO_SUNDAY },
  { value: "no_guest", label: "No trajeron invitado" },
];
